


































































































import Vue from 'vue'
import { filter, find } from 'lodash'
import { mapActions, mapMutations } from 'vuex'
import { NotNull, Unpacked } from '@/utils'
import { Action, Offer } from '@/store/interview/offers'
import { Booking } from '@/store/interview/bookings'
import Editor from '@/components/artifacts/NewEditor'
import { TaskLog } from '../../store/workflow/types'

type ActiveBooking = Unpacked<NotNull<NotNull<Offer>['activeBookings']>['nodes']>

type CanceledBooking = Unpacked<NotNull<NotNull<Offer>['canceledBookings']>['nodes']>

export default Vue.extend({
  components: { Editor },
  computed: {
    activeBooking(): Booking | undefined {
      if (this.value.activeBookings.nodes.length) {
        return this.value.activeBookings.nodes[0]
      } else {
        return undefined
      }
    },
    hasTakenPlace(): boolean {
      return !!this.value.hasTakenPlace
    },
    soon(): boolean {
      return !!this.value.soon
    },
    startsAt(): Date {
      return new Date(this.value!.timeSlot!.start!.value)
    },
    endsAt(): Date {
      return new Date(this.value!.timeSlot!.end!.value)
    },
    upcoming(): boolean {
      const now = new Date()
      return now <= this.startsAt
    },
    present(): boolean {
      return !(this.past || this.upcoming)
    },
    past(): boolean {
      const now = new Date()
      return this.endsAt < now
    },
    canceled(): boolean {
      return !!this.value!.canceled
    },
    foreign(): boolean {
      return this.value!.interviewerId !== this.$store.getters.currentUserId
    },
    adoptible(): boolean {
      return this.canceled && this.foreign
    },
    adoptTask(): TaskLog | undefined {
      return find(this.$store.getters['workflow/dueTasks'] as TaskLog[], {
        task_definition_key: 'take-over-appointment',
        local_variables: { offerId: this.value.id },
      })
    },
    booked(): boolean {
      return this.activeBookings.length > 0
    },
    canceledByInterviewee(): boolean {
      return this.canceledBookings.length > 0
    },
    activeBookings(): ActiveBooking[] {
      return this.value!.activeBookings!.nodes
    },
    canceledBookings(): CanceledBooking[] {
      return this.value!.canceledBookings!.nodes
    },
    post(): boolean {
      return !!this.value!.post
    },
  },
  data() {
    return { changes: null }
  },
  methods: {
    ...mapActions('interview/offers', ['cancel', 'update']),
    ...mapMutations('interview/offers', ['selectToEdit']),
    uncancel() {
      if (this.booked && !this.adoptTask) {
        throw new Error('booked tasks should be uncancelled by adoption')
      }
      if (this.adoptTask) {
        return this.$store
          .dispatch({ type: 'workflow/completeTask', task: this.adoptTask })
          .then(() => {
            return this.$store.dispatch({ type: 'interview/fetch' })
          })
      } else {
        return this.$store
          .dispatch({ type: 'interview/offers/uncancel', offer: this.value })
          .catch(error => {
            window.alert(`error: ${error.message}`)
          })
      }
    },
    adopt() {
      if (this.adoptible && this.adoptTask) {
        return this.$store
          .dispatch({ type: 'workflow/completeTask', task: this.adoptTask })
          .then(() => {
            return this.$store.dispatch({ type: 'interview/fetch' })
          })
      } else {
        if (!this.adoptible) {
          console.error('task is not adoptible')
        }
        if (!this.adoptTask) {
          console.error('adoptTask is undefined')
        }
      }
    },
    setExternalLink(offer: Offer) {
      if (offer.externalLink) {
        return this.$store.dispatch({
          type: 'interview/offers/setExternalLink',
          offer,
          link: offer.externalLink,
        })
      }
    },
    cancelMe() {
      if (
        !this.booked ||
        window.confirm(
          (this.$t('interview.therapistConfirmsCancellation') as string) ||
            'You are cancelling a booked appointment. Do you want to proceed?'
        )
      ) {
        this.$store.dispatch({
          type: 'interview/offers/cancel',
          offer: this.value,
        })
      }
    },
  },
  props: {
    value: {
      type: Object as () => Offer,
      required: true,
    },
  },
})
